import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { AdminInstance } from "../utils/adminClass";

export const AdminNotificationsComponent = ({}) => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const submitNotification = async (e: any) => {
    e.preventDefault();
    const notification = {
      title: title,
      body: body,
    };
    const response = await AdminInstance.sendGlobalNotification(notification);
    console.log(response);

    setTitle("");
    setBody("");
  };

  const handleDeleteItem = async (e: any) => {
    e.preventDefault();
    const itemId = e.target.elements.itemId.value;
    const itemType = e.target.elements.itemType.value;

    console.log("itemId", itemId);
    console.log("itemType", itemType);
    const response = await AdminInstance.deleteItem(itemId, itemType);
    console.log(response);
  };

  // 58
  // 59
  // 60
  // 61
  // 57
  // 63
  // 62
  // 56
  // 54

  return (
    <Container>
      <Row>
        <Col>
          <h1>Notifications</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form onSubmit={submitNotification}>
            <Form.Group controlId="notificationTitle">
              <Form.Label>Notification Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter notification title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="notificationBody">
              <Form.Label>Notification Body</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter notification body text"
                onChange={(e) => setBody(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" type="submit" style={{ marginTop: 10 }}>
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <h2>DELETE TEMPORARILY</h2>
          {/* input for a number ID */}
          <Form onSubmit={handleDeleteItem}>
            <Form.Group controlId="itemId">
              <Form.Label>Notification ID</Form.Label>
              <Form.Control type="number" placeholder="Enter the ID of the item to delete" />
            </Form.Group>
            {/* select for a type  */}
            <Form.Group controlId="itemType">
              <Form.Label>Item Type</Form.Label>
              <Form.Control as="select">
                <option>experience</option>
              </Form.Control>
            </Form.Group>
            <Button variant="danger" type="submit">
              Delete
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};
